import { useOrganizations } from '../useOrganization';

/** True if the current user belongs to any AccessID organization. */
export function useIsAccessIdUser(): boolean {
  const { data: organizations = [] } = useOrganizations();
  return organizations.length > 0;
}
